import {ThemedApp} from 'clayco-bootstrap-app';
import {Route, Routes, BrowserRouter } from 'react-router-dom';
import Home from './pages/home';
import store from './redux/store';
import './App.css';
import ChangeLanguageButton from './components/changeLanguageButton';
import { Provider } from 'react-redux';
import ValidatePhoneNumber from './pages/ValidatePhoneNumber';
import WorkerCreated from './pages/worker-created';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from 'providers/AppInsights';

function App() {
  return (
    <Provider store={store}>
      <AppInsightsContext.Provider value={reactPlugin}>
        <BrowserRouter>
          <div className='App'>
            <ThemedApp title={"Safety Work Rules"} customButtons={<ChangeLanguageButton />}>
            <Routes>
              <Route exact path="/ValidatePhoneNumber/:associateId" element={<ValidatePhoneNumber/>}/>
              <Route exact path="/" element={<Home/>}/>
              <Route exact path="/WorkerCreated" element={<WorkerCreated/>}/>
              <Route path="/*" element={<Home/>}/>
            </Routes>
            </ThemedApp>
          </div>
        </BrowserRouter>
      </AppInsightsContext.Provider>
    </Provider>
  );
}

export default App;
